import { useState, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import { NavLink, Link, useRouteLoaderData, Form  } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightToBracket, faRightFromBracket, faShoppingCart, faHome, faFilePen, faUser, faClipboard, faBars } from '@fortawesome/free-solid-svg-icons';

import { getLabConfig } from '../../utils/api';
import FileDisplay from '../../utils/FileDisplay';
import HamburgerMenu from './HamburgerMenu';
import MenuContext from '../../store/MenuContext';
import LabIDContext from '../../store/LabIDContext';
import HeaderClasses from './AppHeader.module.css';
import { useLocation } from 'react-router-dom';

const AppHeader = () => {
	const cartState = useSelector(state => state.cart);
	const [portalTitle, setPortalTitle] = useState([]);
	const token = useRouteLoaderData('root');
	const labtestid = sessionStorage.getItem("Labtestid");
	const [PPURL, setPPURL] = useState([]);

	const [menuIsOpen, setMenuIsOpen] = useState(false);
    const menuHandler = () => {
		setMenuIsOpen(!menuIsOpen)
		};
	const onMenuSelect = () => {menuHandler()};
	const location = useLocation();
	useEffect(() => {
		const pageHasCustomTitle = location.pathname.startsWith('/details/') || location.pathname === '/' || location.pathname.startsWith('/AvailableTest');
		// console.log(location.pathname);
		async function fetchPortalTitle() {
			const portalTitle = await getLabConfig('DTCLABEL');
			setPortalTitle(portalTitle);
			const PPURL = await getLabConfig("PPWEBSERVER");
			setPPURL(PPURL);
			if (!pageHasCustomTitle) {
				document.title = portalTitle;
			}
		}
		fetchPortalTitle();
    }, []);
	const menuTheme = useContext(MenuContext);
	const labid = useContext(LabIDContext);
	//const historyURL = "localhost:3000/patientportal/" + labid + "/history?token=" + token + "&labtestid=" + labtestid;	
    const historyURL = PPURL +"RPP/" + labid + "/patientportal/" + labid + "/history?token=" + token + "&labtestid=" + labtestid;
    const loginLink = <Link to='Login' className={HeaderClasses.navItem} title="Login">
        <FontAwesomeIcon icon={faRightToBracket} className={HeaderClasses.headerIcon}/>
		</Link>;
    const logoutLink = <Form action="/logout" method="post">
                 <button className={HeaderClasses.navItem} title="Logout" ><FontAwesomeIcon icon={faRightFromBracket} className={HeaderClasses.headerIcon}/></button> 
           </Form>;
	const [istest, setIstest] = useState(null);
	useEffect(() => {
		  const raw = sessionStorage.getItem("ISTEST");
		  if (raw === null) return; // wait until it is set
		  setIstest(raw.trim() === "1");
		}, []);


    return (
	<>
		<FileDisplay filePath={`${labid}_Header.js`} />
		{menuTheme === "TOP" &&
			<header className={HeaderClasses.appHeader}>
				<NavLink to='' aria-label={portalTitle}> 
					<img className={HeaderClasses.labLogo} alt='' src={`/images/logos/${labid}.gif`} style={{ width: '220px', height: 'auto', paddingTop:'5px'}}/>
				</NavLink>
				<div className={HeaderClasses.titleArea}>
					<div>
						{istest === true && <span className={HeaderClasses.titlered}>TEST ONLY:</span>}
						<span className={HeaderClasses.title}>{portalTitle}</span>
					</div>
					<nav className={HeaderClasses.headerNav}>
						<NavLink to='' className={HeaderClasses.navItem} title="Home">
							<FontAwesomeIcon icon={faHome} className={HeaderClasses.headerIcon}/>
						</NavLink>
						{token &&<NavLink to='orderHistory' className={HeaderClasses.navItem} title="Order History">
							<FontAwesomeIcon icon={faClipboard} className={HeaderClasses.headerIcon}/>
						</NavLink>}
						{token &&<a href= {historyURL} className={HeaderClasses.navItem} title="Results" target="_RPP">
							<FontAwesomeIcon icon={faFilePen} className={HeaderClasses.headerIcon} />
						</a>}
						<NavLink to='cart' className={HeaderClasses.navItem} title="Cart">
						  <span className={HeaderClasses.cartIconWrapper}>
							{cartState.totalQuantity >= 1 && (
							  <span className={HeaderClasses.cartAmount}>
								{cartState.totalQuantity}
							  </span>
							)}
							<FontAwesomeIcon icon={faShoppingCart} className={HeaderClasses.headerIcon} />
						  </span>
						</NavLink>
						{token &&<NavLink to='userProfileEdit' className={HeaderClasses.navItem} title="Edit User Profile">
							<FontAwesomeIcon icon={faUser} className={HeaderClasses.headerIcon}/>
						</NavLink>}
						
						{!token && loginLink}
						{token && logoutLink}
						
					</nav>
				</div>
			</header>
	}
	{menuTheme === "HAMBURGER" &&
			<header className={HeaderClasses.appHeader} style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<div style={{ display: 'flex', alignItems: 'center', flex: '0 0 auto' }}>
					  <NavLink to=''>
						<img
						  className={HeaderClasses.labLogoLeft}
						  alt=''
						  src={`/images/logos/${labid}.gif`}
						/>
					  </NavLink>
					</div>

					<div style={{
					  position: 'absolute',
					  top: '50%',
					  left: '50%',
					  transform: 'translate(-50%, -50%)',
					  zIndex: 1
					}}>
					  <NavLink to=''>
						  <img
							className={HeaderClasses.labLogoCenter}
							alt=''
							src={`/images/logos/${labid}_2.gif`}
							style={{ width: 'auto', height: 'auto', paddingTop: '5px', maxHeight: '60px' }}
						  />
					   </NavLink>
					</div>


				  {/* Right-aligned title and nav */}
				  <div style={{ display: 'flex', alignItems: 'center', flex: '0 0 auto' }}>
					<div className={HeaderClasses.titleArea}>
					  <span className={HeaderClasses.title}>{portalTitle}</span>
					</div>
					<nav className={HeaderClasses.headerNav}>
					 {istest === true && <span className={HeaderClasses.titlered}>TEST ONLY</span>} 

					  <NavLink to='cart' className={HeaderClasses.navItem} title="Cart">
					  <div className={HeaderClasses.cartIconWrapper}>
						<img
						  className={HeaderClasses.cartImage}
						  src={`/images/HamburgerIcons/Add to Cart.png`}
						  style={{ width: '48px', height: 'auto', paddingTop: '5px' }}
						/>
						{cartState.totalQuantity >= 1 && (
						  <span className={HeaderClasses.cartAmountHam}>
							{cartState.totalQuantity}
						  </span>
						)}
					  </div>
					</NavLink>

					<button aria-label="Menu" className={HeaderClasses.menuButton} onClick={menuHandler}>
					  <img
						className={HeaderClasses.hamburgerImage}
						src={`/images/HamburgerIcons/Hamburger Menu.png`}
						style={{ width: '48px', height: 'auto', paddingTop: '5px' }}
					  />
					</button>
					{menuIsOpen && (
					  <>
						<HamburgerMenu onMenuSelect={onMenuSelect} />
						<div className={HeaderClasses.menuOpen}></div>
					  </>
					)}
					  <div className={HeaderClasses.menuOverlayOpen}></div>
					</nav>
				  </div>
			</header>



	}
	</>
    );
};

export default AppHeader;